import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DaybookService = {
  closeSummary: async (startDate, endDate) => {
    try {
      const response = await apiService.post(
        `/dayclose/closeandsummary`
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  orderSummary: async (startDate, endDate) => {
    const response = await apiService.get(
      `/dayclose/ordersummaries`
    );
    return response.data;
  },
  paymentTypeSummary: async (startDate, endDate) => {
    const response = await apiService.get(
      `/dayclose/paymenttypesummary`
    );
    return response.data;
  },
};

export default DaybookService;
